/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/2/28
 */
import {currentTree as queryCurrent, departments} from 'crm/services/departments'
import {query as queryRoles} from 'crm/services/roles'
import {
    query,
    setRole,
    setDepartment,
    updateTeamData,
    updateTeamDataState,
    usersIndependent,
    usersIndependentDetails,
    changeCreator,
    exportSensitiveEditExcel,
} from 'crm/services/users'
import {companyPermissionsAll, companyPermissionsUpdate} from 'crm/services/permissions'
import createModel from 'utils/model'
import {treeForEach} from 'utils'
import _ from 'lodash'

function getInitParams() {
    return {
        query: '',
        role: undefined,
        permission_status: undefined,
        hide_empty_role: 0,
        limit: 10,
        offset: 0,
    }
}

function getInitState() {
    return {
        tree: [],
        users: [],
        independentUsers: [],
        params: getInitParams(),
        total: 0,
        current: 1,
        showMoreDepartment: false,
        activeDepartment: null,
        activeIndependentUser: null,
        independentUserShow: false,
        expandedKeys: [],
        roles: [],
        rolesMap: new Map(),
        companyPermissionsMap: new Map(),
        selectedRowKeys: [],
        updateTeamDataLoading: false,
        updateTeamTaskTimer: null,
    }
}

export default createModel({
    namespace: 'crm_teamManagement',

    state: getInitState(),

    effects: {
        *changeCreator({payload}, {call}) {
            return yield call(changeCreator, payload)
        },

        *getDepartments({payload}, {call}) {
            return yield call(departments, payload)
        },

        *usersIndependent({payload}, {call, put}) {
            const {data} = yield call(usersIndependent, payload)

            yield put({
                type: 'setProperty',
                payload: {
                    independentUsers: data,
                },
            })
        },
        *companyPermissionsAll({payload}, {call, put}) {
            const {data} = yield call(companyPermissionsAll, payload)

            const companyPermissionsMap = new Map()
            data.forEach((item) => {
                companyPermissionsMap.set(item.id, item)
            })

            yield put({
                type: 'setProperty',
                payload: {
                    companyPermissionsMap,
                },
            })
        },
        *companyPermissionsUpdate({payload}, {call}) {
            yield call(companyPermissionsUpdate, payload)
        },
        *usersIndependentDetails({payload}, {call}) {
            return yield call(usersIndependentDetails, payload)
        },
        *setDepartment({payload}, {call}) {
            yield call(setDepartment, payload)
        },
        *setRole({payload}, {call}) {
            yield call(setRole, payload)
        },
        *roles({payload}, {call, put}) {
            const {data} = yield call(queryRoles, payload)

            const rolesMap = new Map()
            data.forEach((item) => {
                rolesMap.set(item.id, {
                    key: item.id,
                    value: item.id,
                    name: item.name,
                })
            })

            yield put({
                type: 'setProperty',
                payload: {
                    roles: data,
                    rolesMap,
                },
            })
        },
        *tree({payload}, {call, select, put}) {
            const {meta, data} = yield call(queryCurrent, payload)

            if (meta?.code === 103036) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        showMoreDepartment: true,
                    },
                })

                return
            }

            treeForEach(data, (item, parent) => {
                item.parent = parent
            })

            yield put({
                type: 'setProperty',
                payload: {
                    tree: data,
                },
            })
            const expandedKeys = yield select(
                ({crm_teamManagement}) => crm_teamManagement.expandedKeys,
            )
            if (!expandedKeys.length) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        expandedKeys: [String(_.get(data, '[0].id'))],
                    },
                })
            }

            const activeDepartment = yield select(
                ({crm_teamManagement}) => crm_teamManagement.activeDepartment,
            )

            if (!activeDepartment && data[0]) {
                yield put({
                    type: 'setActiveDepartment',
                    payload: data[0],
                })
            }
        },
        *queryUsers({payload}, {select, call, put}) {
            const {params, current, initData} = yield select(({crm_teamManagement, auth}) => ({
                params: crm_teamManagement.params,
                current: crm_teamManagement.current,
                initData: auth.initData,
            }))

            const newParams = {...params}

            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)

                yield put({
                    type: 'mergeTableParamsName',
                    payload: {
                        offset: newParams.offset,
                    },
                })
            }

            const activeDepartment = yield select(
                ({crm_teamManagement}) => crm_teamManagement.activeDepartment,
            )
            if (activeDepartment) {
                newParams.department_id = activeDepartment.id
            } else {
                newParams.department_id = ''
            }

            newParams.hide_empty_role = Number(newParams.hide_empty_role)
            newParams.with_user_permission = initData?.company?.permission_limit_close ? 0 : 1
            newParams.with_work_permission = 1

            const res = yield call(query, newParams)

            yield put({
                type: 'setProperty',
                payload: {
                    users: res.data,
                    total: _.get(res, 'pagination.rows_found', 0),
                    current: _.get(payload, 'page', current),
                    selectedRowKeys: [],
                },
            })
        },
        // 团队管理-更新团队数据
        *updateTeamData(xx, {call}) {
            return yield call(updateTeamData)
        },
        *updateTeamDataState({payload}, {call}) {
            return yield call(updateTeamDataState, payload)
        },

        // 导出系统操作日志
        *exportSensitiveEditExcel({payload}, {call}) {
            return yield call(exportSensitiveEditExcel, payload)
        },
    },

    reducers: {
        resetInitState(state) {
            return {
                ...getInitState(),
                updateTeamDataLoading: state.updateTeamDataLoading,
                updateTeamTaskTimer: state.updateTeamTaskTimer,
            }
        },
        mergeTableParamsName(state, action) {
            return {...state, params: {...state.params, ...action.payload}}
        },
        resetParams(state) {
            return {...state, params: getInitParams()}
        },
        clearSelectedRowKeys(state) {
            return {...state, selectedRowKeys: []}
        },
        setActiveDepartment(state, action) {
            return {...state, ...{activeDepartment: action.payload, independentUserShow: false}}
        },
        setActiveIndependentUser(state, action) {
            return {...state, ...{activeIndependentUser: action.payload, independentUserShow: true}}
        },
    },
})
